// extracted by mini-css-extract-plugin
export default {"userOverview":"UserOverview_userOverview__iUSQ4","tableWrapper":"UserOverview_tableWrapper__KTEHw"};